import AxiosClient from "../AxiosClient";

// ログイン認証Api
export const postLoginAPI = (params) => {
  return AxiosClient.post("/api/authority/login", params);
}